<template>
  <div class="pageContent">
    <div class="pageContent-left">
      <div class="pageContent-left-top">信息发布</div>
      <ul class="pageContent-left-bottom">
        <li @click="toggleNotice(1)" :class="{'pageContent-left-bottom-item':true,'pageContent-left-bottom-itemActive':type==1}">通知公告</li>
        <li @click="toggleNotice(2)" :class="{'pageContent-left-bottom-item':true,'pageContent-left-bottom-itemActive':type==2}">新闻资讯</li>
<!--        <li @click="toggleNotice(4)" :class="{'pageContent-left-bottom-item':true,'pageContent-left-bottom-itemActive':type==4}">学校通知</li>
        <li @click="toggleNotice(5)" :class="{'pageContent-left-bottom-item':true,'pageContent-left-bottom-itemActive':type==5}">培训通知</li>
        <li @click="toggleNotice(2)" :class="{'pageContent-left-bottom-item':true,'pageContent-left-bottom-itemActive':type==2}">新闻资讯</li>-->
        <li @click="toggleNotice(3)" :class="{'pageContent-left-bottom-item':true,'pageContent-left-bottom-itemActive':type==3}">规章制度</li>
      </ul>
    </div>
    <div class="pageContent-right">
      <div class="pageContent-right-top" @click="detailFlag=false">
        {{type==1?'通知公告':type==2?'新闻资讯':'规章制度'}}
        <span v-if="detailFlag" class="pageContent-right-top-back">返回</span>
      </div>
      <template v-if="!detailFlag">
        <div class="pageContent-right-search">
          <img class="pageContent-right-search-img" src="../../assets/images/find.png" alt="">
          <input v-model="value" type="text" class="pageContent-right-search-input">
          <button @click="search" class="pageContent-right-search-btn">检索</button>
        </div>
        <ul class="pageContent-right-list">
          <li v-for="item in list" @click="getDetail(item)" :key="item.id" class="pageContent-right-list-li">
            <div class="pageContent-right-list-li-title">{{item.headline}}</div>
            <div class="pageContent-right-list-li-date">{{item.addTime}}</div>
          </li>
        </ul>

        <div class="pageContent-right-paginationBox">
          <a-pagination size="small" :total="total" :current="current" :pageSize="10" show-quick-jumper @change="tableChange" :show-total="total => `共${total}条记录`" />
        </div>
      </template>
      <div class="pageContent-right-content" v-else>
        <div class="top">
          <h2 class="title">{{ title }}</h2>
          <div class="date">{{ addTime }}</div>
        </div>
        <div class="content" ref="content"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import { http } from '../../utils/http'

  export default {
    data() {
      return {
        total: 0,
        type: 1,
        current: 1,
        list: [],
        value: undefined,
        title: '',
        addTime: '',
        detailFlag: false,
        rulesList: [],
        countryList: [],
      }
    },
    created() {
      if (this.$route.query.type) this.type = this.$route.query.type
      if (this.$route.query.noticeId) this.getAllList()
      this.getList()
    },
    methods: {
      // 请求获取列表
      getList() {
        let parameter = {
          type: this.type,
          pageNum: this.current,
          pageSize: 10,
        }
        this.list = []
        http('/system/announcement/getList', 'POST', parameter).then(res => {
          if (res.success) {
            this.loading = false
            let list = res.data.resultList
            this.total = res.data.total
            this.list = list
          }
        })
      },
      // 请求列表所有数据
      getAllList() {
        let parameter = {
          type: this.type,
          pageNum: 1,
          pageSize: 9999,
        }
        http('/system/announcement/getList', 'POST', parameter).then(res => {
          if (res.success) {
            let list = res.data.resultList
            list.forEach(item => {
              if (item.id === this.$route.query.noticeId) this.getDetail(item)
            })
          }
        })
      },
      // 切换信息类型
      toggleNotice(type) {
        this.type = type
        this.detailFlag = false
        this.getList()
      },
      search() {
        this.current = 1
        this.getList()
      },
      tableChange(page) {
        this.current = page
        this.getList()
      },
      // 查看详情
      getDetail(row) {
        this.detailFlag = true
        this.title = row.headline
        this.addTime = row.addTime
        this.$nextTick(() => {
          this.$refs.content.innerHTML = row.content
        })
      },
    }
  }
</script>

<style lang="less" scoped>
.pageContent {
  width: 1220px;
  margin: 18px auto;
  display: flex;
  justify-content: space-between;
  box-shadow: unset;
  padding: 0;
  background: unset;
  &-left {
    width: 188px;
    background-color: #fff;
    &-top {
      font-size: 20px;
      color: #fff;
      background-color: #4AB0F1;
      line-height: 44px;
      height: 44px;
      border-radius: 2px;
      position: relative;
      text-align: center;
      margin-bottom: 15px;
      &::before {
        content: '';
        position: absolute;
        left: 86px;
        bottom: -20px;
        border: 10px solid transparent;
        border-top-color: #4AB0F1;
      }
    }
    &-bottom {
      border: 1px dashed #dddddd;
      padding: 3px 3px 2px 3px;
      margin-bottom: 1px;
      list-style-type: none;
      &-item {
        border: 1px solid #dddddd;
        display: block;
        background-color: #eeeeee;
        background-image: url(../../assets/images/arrow_t0.gif);
        background-position: 0 3px;
        background-repeat: no-repeat;
        padding: 0px 5px 0px 18px;
        color: #0E7ACB;
        font-size: 14px;
        line-height: 32px;
        transition: all .3s ease-in-out;
        cursor: pointer;
        &:hover {
          background-color: #4FABDD;
          color: #FFF;
          border-color: #53A2E1;
          background-position: 0 122%;
        }
      }
      &-itemActive {
        background-color: #4FABDD;
        color: #FFF;
        border-color: #53A2E1;
        background-position: 0 122%;
      }
    }
  }
  &-right {
    width: calc(100% - 206px);
    background-color: #fff;
    padding: 14px;
    &-top {
      background-image: url(../../assets/images/t_bk_l.png);
      background-repeat: no-repeat;
      background-color: #EEE;
      line-height: 32px;
      margin-bottom: 8px;
      color: #FFF;
      line-height: 32px;
      font-size: 12px;
      padding: 0px 0px 0px 30px;
      font-weight: bold;
      cursor: pointer;
      &-back {
        float: right;
        color: #4AB0F1;
        font-size: 15px;
        margin-right: 12px;

      }
    }
    &-search {
      margin: 0px 0px 15px 0px;
      border: 1px dashed #dddddd;
      padding: 5px 5px 5px 15px;
      display: flex;
      align-items: center;
      &-input {
        outline: 0;
        padding: 3px;
        width: 40%;
        border: 1px solid #cccccc;
        margin-left: 10px;
      }
      &-btn {
        border: 0;
        height: 29px;
        padding-left: 15px;
        padding-right: 15px;
        font-size: 14px;
        background: #0084e9;
        color: #fff;
        border-radius: 4px;
        -webkit-transition: all .2s ease;
        transition: all .2s ease;
        outline: 0;
        vertical-align: middle;
        margin-left: 5px;
        cursor: pointer;
      }
    }
    &-list {
      padding: 5px 5px 33px 5px;
      // border: 1px dashed #CCC;
      font-size: 14px;
      color: #666;
      list-style: none;
      &-title {
        font-weight: 600;
        font-size: 15px;
        margin-bottom: 8px;
        display: block;
        color: #4FABDD;
      }
      &-li {
        height: 40px;
        border-bottom: 1px dashed #D8E6EF;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        &:hover {
          border-bottom: 1px dashed #4AB0F1;
          background-color: #f5f5f5;
        }
        &-title {
          color: #444;
          padding-left: 15px;
          position: relative;
          font-size: 15px;
          &::before {
            content: '';
            position: absolute;
            left: 5px;
            top: 7px;
            border: 3px solid transparent;
            border-left-color: #4AB0F1;
          }
        }
        &-date {
          color: #666;
          padding-right: 5px;
        }
      }
    }
    &-paginationBox {
      text-align: right;
      margin-top: -7px;
    }

    &-content {
      margin-bottom: 10px;
      padding: 10px 16px 0px 16px;
      border: 1px dashed #3F9FD0;
      .top {
        text-align: center;
        color: #666666;
        border-bottom: 1px solid #3F9FD0;
        margin-bottom: 10px;
        .title {
          font-size: 24px;
          color: rgb(68, 68, 68);
          padding: 10px 10px 6px;
          margin: 0;
        }
        .date {
          padding: 10px 0px;
        }
      }
    }
  }
}
</style>
